import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4002a3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-content auth-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前软件暂未进行授权，为不影响您的场景计算，请尽快进行授权。", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "授权操作流程详见操作手册或联系工作人员。", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前有效许可证如下：", -1 /* HOISTED */))
const _hoisted_5 = {
  key: 0,
  class: "success"
}
const _hoisted_6 = {
  key: 1,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$setup.showInfo)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _hoisted_3,
            _createCommentVNode(" <div class=\"update\">\n          <a-button type=\"ghost\" size=\"large\" @click=\"visible = true\">现在授权</a-button>\n        </div> ")
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_4,
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              bordered: "",
              class: "content-table camera-table",
              rowKey: "keyId",
              columns: $setup.columns,
              "data-source": [$setup.showInfo],
              pagination: false
            }, {
              use: _withCtx(({ record }) => [
                (record.use)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "使用中"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, " 已过期 "))
              ]),
              surplus: _withCtx(({ record }) => [
                _createElementVNode("span", {
                  class: _normalizeClass(!record.use || record.surplus < 0 ? 'error' : 'success')
                }, _toDisplayString($setup.getSurplus(record.surplus)), 3 /* TEXT, CLASS */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["data-source"]),
            _createCommentVNode(" <div class=\"update\" style=\"margin-top: 20px\">\n          <a-button type=\"ghost\" size=\"large\" @click=\"visible = true\">授权</a-button>\n        </div> ")
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _createCommentVNode(" <a-modal \n      :visible=\"visible\" \n      title=\"四维深时本地版\" \n      @cancel=\"visible = false\" \n      :footer=\"null\" \n      width=\"700px\"\n      class=\"dialog\">\n      <div class=\"modal-layout auth-content\">\n        <div class=\"logo\">\n          <i class=\"iconfont icon-a-4dkankan-g\"></i>\n        </div>\n        <div class=\"info\">\n          <h3>正在进行软件授权</h3>\n          <div>\n            <p>如果您购买了授权秘钥，请在下方输入。</p>\n            <p>如果您还没有授权秘钥，请点击“获取机器码”，并联系工作人员获取密钥。</p>\n          </div>\n          <div class=\"input aaaa\">\n            <a-input-search :value=\"info.keyId\" placeholder=\"input search text\"  >\n              <template #enterButton>\n                <span @click=\"copy\">复制机器码</span>\n              </template>\n            </a-input-search>\n          </div>\n          <h3>授权秘钥</h3>\n          <div class=\"input\">\n            <a-input-search v-model:value=\"secret\" placeholder=\"请输入授权秘钥\"  class=\"input\" >\n              <template #enterButton>\n                <span type=\"primary\" size=\"large\" @click=\"authSecret()\">验证授权</span>\n              </template>\n            </a-input-search>\n          </div>\n        </div>\n      </div>\n  </a-modal> ")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}